import LoggedInUser from './logged-in-user-view'
export default LoggedInUser
